import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
import Select from "../../local_node_modules/react-select"
import Alert from "react-s-alert";
import {Label} from "reactstrap";
import '../memberList/MemberList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";

class CityTransferModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            cities: [],
            toBranch: null,
            selectedCity: {
                id: null,
                plakaKod: null,
                ad: null,
                oda: {
                    id: null,
                    ad: null,
                    adres: null,
                    telefonNo: null,
                    email: null,
                    webSitesiURL: null,
                    kurulusKararNo: null
                }
            },
        };

        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.transferCity = this.transferCity.bind(this);
    }

    componentDidMount() {
        if (this.props.selectedCity) {
            let selectedCity = deepCopyObject(this.props.selectedCity);
            this.setState({selectedCity});
        }
    }


    onChangeSelect(name, value) {
        let toBranch;
        if (value === null) {
            toBranch = null
        } else {
            toBranch = value.value;
        }
        this.setState({toBranch});
    }

    updateBranchIds = (data) => {
        let self = this;
        let params;
        params = {
            url: API_BASE_URL + "/financial-transaction/update-branchIds",
            data: data,
            method: 'post'
        };
        request(params).then(() => {
            Alert.success(
                'Şehir aidat tahakkukları başarıyla güncellendi.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    updateMemberNos = (data) => {
        let self = this;
        let params;
        params = {
            url: API_BASE_URL + "/uye/update-member-nos",
            data: data,
            method: 'post'
        };
        request(params).then(() => {
            Alert.success(
                'Şehir üye sicil numaraları başarıyla güncellendi.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }


    transferCity() {
        let self = this;
        let cities = [];
        let params;
        let data = {};

        cities.push(this.props.selectedCity.id);
        self.setState({isLoading: true});
        data.cities = cities;
        data.toBranch = this.state.toBranch;
        params = {
            url: API_BASE_URL + "/city/update-branch",
            data: data,
            method: 'post'
        };
        request(params).then(() => {
            Alert.success(
                'Şehrin oda numarası başarıyla güncellendi.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.updateMemberNos(data);
            self.updateBranchIds(data);
            self.setState({isLoading: false});
            this.cancelProcess();
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }


    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">Şehir Bilgileri</h4>
                </div>
                <div className="memberTransferForm-container">
                    <div className="card-body mt-1">
                        <div className="FormRenk col-sm-12">
                            <div className="row">
                                <Label className="col-sm-2">Plaka Kodu:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.plakaKod}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Ad:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Oda:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.oda.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Adres:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.oda.adres}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Telefon:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.oda.telefonNo}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Email:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.oda.email}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Web Sitesi:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.oda.webSitesiURL}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Kuruluş Karar No:</Label>
                                <Label className="col-sm-10">{this.state.selectedCity.oda.kurulusKararNo}</Label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-header'>
                    <h4 className="card-title">Transfer Edileceği Oda</h4>
                </div>
                <div className="memberTransferForm-container">
                    <div className="card-body mt-1">
                        <div className="FormRenk col-sm-12">
                            <div className="row">
                                <Label className="col-sm-2">Oda:</Label>
                                <div className="col-sm-10 form-group">
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Oda seçiniz."
                                        isClearable={false}
                                        isSearchable={false}
                                        name="branch"
                                        id="tBranch"
                                        ref="tBranch"
                                        style={{width: 400}}
                                        inputProps={{'vdata': "required"}}
                                        options={this.props.branches.map(branch => ({
                                            value: branch.value,
                                            label: branch.label
                                        }))}
                                        onChange={(value) => this.onChangeSelect("toBranch", value)}
                                        value={this.state.toBranch}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px',width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal Et
                            </button>
                        </div>
                        <div className="col-sm-8"/>
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"180px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={!this.state.toBranch}
                                    onClick={() => this.transferCity()}>Transfer İşlemini Onayla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CityTransferModal;


// WEBPACK FOOTER //
// ./src/page/cityTransfer/CityTransferModal.js